export var tab = 'agency';
export var sort = 'SOLD';